import { render } from "./TradePromotionPage.vue?vue&type=template&id=b14966e4"
import script from "./TradePromotionPage.vue?vue&type=script&lang=js"
export * from "./TradePromotionPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/macbook/Documents/freelance/naks/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__